import { queryOptions } from "@tanstack/react-query";
import { ApiError } from "@/lib/api-client";
import { authClient } from "./session";

/** The person signed in, for the account menu: Better Auth's session, not the reseller record. */
export const currentUserQuery = () =>
  queryOptions({
    queryKey: ["auth", "user"],
    queryFn: async () => {
      const { data } = await authClient.getSession();
      if (!data) throw new ApiError(401, "unauthenticated", "Authentication required");
      return { name: data.user.name, email: data.user.email };
    },
  });
